import type { App } from 'vue'
const env = import.meta.env

export function installGlobal(app: App) {
  // 是否是使用线上路由
  app.config.globalProperties.$isBackRouter = env.VITE_USE_LOCAL_ROUTER === 'true'
}
